import { createContext, useState, type ReactNode } from "react";

interface Filters {
  projectIds: string[];
  timeFilter: string;
  agentNames: string[];
}

const FiltersContext = createContext<{
  filters: Filters;
  setFilters: (filters: Filters) => void;
} | null>(null);

export const FiltersProvider = ({ children }: { children: ReactNode }) => {
  const [filters, setFilters] = useState<Filters>({
    projectIds: [],
    timeFilter: "",
    agentNames: [],
  });

  return (
    <FiltersContext.Provider value={{ filters, setFilters }}>
      {children}
    </FiltersContext.Provider>
  );
};

export { FiltersContext };
